import React from 'react';
import SidebarLink from './SidebarLink';
import { TruncateWord } from '../../_deprecated';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export function SidebarPrimaryLink({ label, icons, ...linkProps }) {
    const modifiedLabel = label.includes(' ')
        ? label.toLowerCase().split(' ').join('-')
        : label.toLowerCase();
    return (React.createElement(SidebarLink, { ...linkProps, className: `dd-dashboard-sidebar-primary-${modifiedLabel}` },
        React.createElement(TruncateWord, null,
            React.createElement("span", { className: "icon iconDefault" },
                React.createElement(icons.default),
                " "),
            React.createElement("span", { className: "icon iconSelected" },
                React.createElement(icons.selected),
                " "),
            label)));
}
